export const keywords = [
    {
        text: '@jeżeli',
        value: '@jeżeli'
    },
    {
        text: "@jest-równe",
        value: "@jest-równe",
    },
    {
        text: '@zakończ-warunek',
        value: '@zakończ-warunek',
    },
    {
        text: '#prawda',
        value: '#prawda'
    },
    {
        text: '#fałsz',
        value: '#fałsz'
    }
];
